import React, { useEffect, useState, useMemo } from 'react';
import { Input, Table, message, Switch, List } from 'antd';
import AxiosOICStat from '../AxiosOICStat';
import { EyeOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { ExpandableTextView } from '../components/ExpandableTextView';
import { Tabs, Button, Modal, Row, Col, Form } from 'antd';
import * as XLSX from 'xlsx';
import { writeExcelFile } from '../utils/excelExport';
import { useSelector } from 'react-redux';
import RoleUtils from '../utils/RoleUtils';

export const Source = () => {
    const [sources, setSources] = useState([]);
    const [allSources, setAllSources] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [isAddMode, setIsAddMode] = useState(false);
    const user = useSelector((state) => state.user);
    const sourcesState = useSelector((state) => state.sources.value);
    const indicatorsState = useSelector((state) => state.indicators && state.indicators.value);
    const unitsState = useSelector((state) => state.units);
    const categoriesState = useSelector((state) => state.categories);
    const [form] = Form.useForm();
    const [searchValue, setSearchValue] = useState('');
    const { Search } = Input;

    // columns for indicators table in modal (match Indicators page)
    const indicatorColumns = [
        {
            title: 'Code', dataIndex: 'ind_code', key: 'ind_code', width: 100,
            render: (indCode) => <Link to={`/indicator/${indCode}`}>{indCode}</Link>,
        },
        {
            title: 'Name', dataIndex: 'ind_name_eng', key: 'ind_name_eng',
            render: (indNameEng, record) => {
                const nameToShow = record && record.is_used ? (record.optional_name || indNameEng) : indNameEng;
                return (
                    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                        <Link to={`/indicator/${record.ind_code}`}>{nameToShow}</Link>
                    </div>
                );
            }
        },
        { title: 'Explanation', dataIndex: 'ind_eng_exp', key: 'ind_eng_exp', render: (text) => <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}><ExpandableTextView text={text} /></div> },
        { title: 'Unit', dataIndex: 'unit_code', key: 'unit_code', width: 140, render: (unitCode) => unitsState?.value?.[unitCode]?.unit_name_eng || unitCode },
        { title: 'Primary Category', dataIndex: 'cat_code', key: 'cat_code', width: 160, render: (catCode) => <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>{categoriesState?.value?.[catCode]?.cat_name_eng || catCode}</div> },
        { title: 'Is private?', dataIndex: 'is_private', key: 'is_private', width: 100, render: (isPrivate) => (isPrivate === 1 ? 'private' : 'non-private') },
        { title: 'Source', dataIndex: 'source_code', key: 'source_code', width: 180, render: (sourceCode) => <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>{(sourcesState && sourcesState[sourceCode]) ? sourcesState[sourceCode].source_name_eng : sourceCode}</div> },
        {
            title: 'Indicator Formula', dataIndex: 'formula', key: 'formula', width: 160,
            render: (formula) => {
                if (!formula) return '-';
                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                        <div style={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 400 }}>{formula}</div>
                        <Button size="small" icon={<EyeOutlined />} onClick={() => {
                            Modal.info({ title: 'Indicator Formula', content: formula, okText: 'Close' });
                        }} />
                    </div>
                );
            }
        },
        { title: 'Aggregation Method', dataIndex: 'aggr_method', key: 'aggr_method', width: 140, render: (aggrMethod) => (aggrMethod !== null ? aggrMethod : '-') },
        { title: 'Aggregation Formula', dataIndex: 'aggr_formula', key: 'aggr_formula', width: 160, render: (v) => (v !== null ? v : '-') },
    ];
    /*
    const [showModalVisible, setShowModalVisible] = useState(false);
    const [wdgSources, setwdgSources] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get('https://api.worldbank.org/v2/sources/all?format=json&per_page=100');
                // Assuming the actual data is in the second element of the response array
                const data = response.data[1].map(item => ({
                    id: item.id,
                    lastUpdated: item.lastupdated,
                    name: item.name,
                    code: item.code,
                    description: item.description,
                    url: item.url,
                    dataAvailability: item.dataavailability,
                    metadataAvailability: item.metadataavailability,
                    concepts: item.concepts
                }));
                setwdgSources(data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    const wdgColumns = [
        { title: 'ID', dataIndex: 'id', key: 'id' },
        { title: 'Last Updated', dataIndex: 'lastUpdated', key: 'lastUpdated' },
        { title: 'Name', dataIndex: 'name', key: 'name' },
        { title: 'Code', dataIndex: 'code', key: 'code' },
        { title: 'Description', dataIndex: 'description', key: 'description' },
        { title: 'URL', dataIndex: 'url', key: 'url' },
        { title: 'Data Availability', dataIndex: 'dataAvailability', key: 'dataAvailability' },
        { title: 'Metadata Availability', dataIndex: 'metadataAvailability', key: 'metadataAvailability' },
        { title: 'Concepts', dataIndex: 'concepts', key: 'concepts' }
    ];
    */

    // Function to convert JSON data to Excel and trigger download
    const exportToExcel = () => {
        // convert isVisible to string
        sources.forEach(source => {
            source.is_visible = source.is_visible ? 'visible' : 'non-visible';
            source.is_private = source.is_private ? 'private' : 'non-private';
        });
        const worksheet = XLSX.utils.json_to_sheet(sources);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sources");

        // Define file name
        let fileName = 'sources.xlsx';

        // Write and download the file
        writeExcelFile(workbook, fileName);
    };


    const handleEdit = (record) => {
        // Implement the edit functionality here
        console.log('Edit', record);

        // Set selectedRecord and editModalVisible to open the modal
        form.resetFields();

        setSelectedRecord(record);
        setEditModalVisible(true);
        setIsAddMode(false);

    };

    const handleEditModalCancel = () => {
        setEditModalVisible(false);
        setIsAddMode(false);
        form.resetFields();
        setSelectedRecord(null);
    };

    /*
    const handleShowModalCancel = () => {
        setShowModalVisible(false);
    };

    const handleShow = (record) => {
        // Implement the show functionality here
        setSelectedRecord(record);
        setShowModalVisible(true);
    };
    */


    const handleEditModalSubmit = (values) => {
        console.log('Received values of form: ', values);

        if (isAddMode) {
            AxiosOICStat.post('sources', values)
                .then(response => {
                    message.success('Source added successfully');
                    setSources(prevSources => [...prevSources, response.data]);
                    setEditModalVisible(false);
                })
                .catch(err => {
                    message.error('Error adding source');
                });
        } else {
            values.source_code = selectedRecord.source_code;
            AxiosOICStat.post(`sources/${selectedRecord.source_code}`, values)
                .then(response => {
                    message.success('Source updated successfully');
                    setSources(prevSources => prevSources.map(source => source.source_code === selectedRecord.source_code ? response.data : source));
                    setEditModalVisible(false);
                })
                .catch(err => {
                    message.error('Error updating source');
                });
        }
    };

    const handleDelete = (source) => {
        Modal.confirm({
            title: 'Are you sure you want to delete this source?',
            onOk: () => {
                AxiosOICStat.delete(`sources/${source}`)
                    .then(() => {
                        console.log('Deleted source:', source);
                        message.success('Source deleted successfully');
                        setSources(prevSources => prevSources.filter(prev_source => prev_source.source_code !== source));
                    })
                    .catch(err => {
                        message.error('Error deleting source');
                    });
            }
        });
    };

    const handleAddNew = () => {
        setSelectedRecord(null);
        setEditModalVisible(true);
        setIsAddMode(true);
        form.resetFields();
    };

    // indicators modal state
    const [indicatorsModalVisible, setIndicatorsModalVisible] = useState(false);
    const [indicatorsOfSource, setIndicatorsOfSource] = useState([]);
    const [indicatorsModalTitle, setIndicatorsModalTitle] = useState('');

    const handleShowIndicators = (source) => {
        let list = [];
        try {
            if (Array.isArray(indicatorsState)) {
                list = indicatorsState;
            } else if (indicatorsState && typeof indicatorsState === 'object') {
                list = Object.values(indicatorsState);
            }
        } catch (err) {
            console.error('Error reading indicators state', err);
        }
        const filtered = list.filter(ind => String(ind.source_code) === String(source.source_code));
        setIndicatorsOfSource(filtered);
        setIndicatorsModalTitle(`${source.source_name_eng || source.source_code} - Indicators`);
        setIndicatorsModalVisible(true);
    };

    const handleSearch = (value) => {
        setSearchValue(value);
        const lowerCaseValue = value.toLowerCase();
        const filtered = allSources.filter(source => {
            const sourceCode = source.source_code || '';
            const sourceName = source.source_name_eng || '';
            return sourceName.toLowerCase().includes(lowerCaseValue) || sourceCode.toString().includes(lowerCaseValue);
        });
        setSources(filtered);
    };

    // Use sources from Redux slice (already fetched elsewhere) instead of refetching
    useEffect(() => {
        setLoading(true);
        try {
            setSources(Object.values(sourcesState));
            setAllSources(Object.values(sourcesState));
        } catch (err) {
            console.error('Error loading sources from state:', err);
            message.error('Error while loading sources');
        } finally {
            setLoading(false);
        }
    }, [sourcesState]);

    // Function to create filter options
    const createFilterOptions = (data, key) => {
        // accept arrays or objects; normalize to array
        let list = [];
        if (!data) return [];
        if (Array.isArray(data)) {
            list = data;
        } else if (typeof data === 'object') {
            list = Object.values(data);
        } else {
            return [];
        }
        const uniqueItems = new Set(list.map(item => item && item[key] ? item[key] : ''));
        return Array.from(uniqueItems).filter(v => v !== '').map(value => ({ text: value, value }));
    };

    // Assuming 'sources' array is already in the desired format
    const sourceNameFilterOptions = useMemo(() => createFilterOptions(sources, 'source_name_eng'), [sources]);

    const columns = [
        {
            title: 'Source Code',
            dataIndex: 'source_code',
            key: 'source_code',
            sorter: (a, b) => a.source_code - b.source_code,
        },
        {
            title: 'Name (English)',
            dataIndex: 'source_name_eng',
            key: 'source_name_eng',
            sorter: (a, b) => a.source_name_eng.localeCompare(b.source_name_eng),
            filters: sourceNameFilterOptions,
            onFilter: (value, record) => record.source_name_eng.includes(value),
            width: '50%'
        },
        {
            title: 'Link',
            dataIndex: 'link',
            key: 'link',
            sorter: (a, b) => a.source_name_eng.localeCompare(b.source_name_eng),
            filters: sourceNameFilterOptions,
            onFilter: (value, record) => record.source_name_eng.includes(value),
            render: (text) => <a href={text} target="_blank" rel="noopener noreferrer">{text}</a>,
        },
        {
            title: 'Is private?',
            dataIndex: 'is_private',
            sorter: (a, b) => a.is_private - b.is_private,
            render: (isPrivate) => (isPrivate === 1 ? 'private' : 'non-private'),
        },
        {
            title: 'Is visible?',
            dataIndex: 'is_visible',
            sorter: (a, b) => a.is_visible - b.is_visible,
            render: (isVisible) => (isVisible === true ? 'visible' : 'non-visible'),
        },
    ];

    RoleUtils.canEditRecords(user.role) && columns.push({
        title: 'Actions',
        dataIndex: '',
        key: 'actions',
        render: (text, record) => (
            <>
                <span style={{ display: "flex" }}>
                    {
                        //<Button icon={<EyeOutlined />} onClick={() => handleShow(record)}></Button>
                    }
                    <Button style={{ marginLeft: 8 }} onClick={() => handleShowIndicators(record)} icon={<EyeOutlined />}>Indicators</Button>
                    <Button style={{ marginLeft: 8 }} type="primary" icon={<EditOutlined />} onClick={() => handleEdit(record)}></Button>
                    <Button style={{ marginLeft: 8 }} type="danger" icon={<DeleteOutlined />} onClick={() => handleDelete(record.source_code)}></Button>
                </span>
            </>
        ),
    });


    const items = [
        {
            key: '1',
            label: 'Source Table',
            children: <Row>
                <Col style={{marginTop: "10px", marginBottom:"10px"}}>
                    {RoleUtils.canEditRecords(user.role) && <Button type="primary" onClick={handleAddNew}>Add New Source</Button>}
                    <Button onClick={exportToExcel} type="primary" style={{ marginLeft: 8 }}>
                        Export to Excel
                    </Button>
                </Col>
                <Search
                placeholder="Search"
                allowClear
                value={searchValue}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ marginBottom: 10 }}
            />
                <Col xs={24}>
                    <Table
                        rowKey="source_code"
                        dataSource={sources}
                        columns={columns}
                        size="small"
                        pagination={{pageSize:"10"}}
                        loading={{ spinning: loading, tip: 'Loading' }}
                    />
                </Col>

                <Modal
                    title="Edit Source"
                    visible={editModalVisible}
                    onCancel={handleEditModalCancel}
                    footer={null}
                    destroyOnClose={true}
                >
                    {/* Show the fields of source here */}
                    <Form form={form} layout="vertical" onFinish={handleEditModalSubmit}>
                        { /**
                        <Form.Item
                            label="Source Code"
                            name="source_code"
                            rules={[{ required: true, message: 'Please input the source code!' }]}
                            initialValue={selectedRecord?.source_code}
                        >
                            <Input />
                        </Form.Item>
                        **/}
                        <Form.Item
                            label="Name (English)"
                            name="source_name_eng"
                            rules={[{ required: true, message: 'Please input the name (English)!' }]}
                            initialValue={selectedRecord?.source_name_eng}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="Is private?"
                            name="is_private"
                            valuePropName="checked"
                            initialValue={selectedRecord?.is_private}
                        >
                            <Switch />
                        </Form.Item>
                        <Form.Item
                            label="Is visible?"
                            name="is_visible"
                            valuePropName="checked"
                            initialValue={selectedRecord?.is_visible}
                        >
                            <Switch />
                        </Form.Item>
                        <Form.Item
                            label="Link"
                            name="link"
                            initialValue={selectedRecord?.link}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="Link (Arabic)"
                            name="link_ar"
                            initialValue={selectedRecord?.link_ar}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="Link (French)"
                            name="link_fr"
                            initialValue={selectedRecord?.link_fr}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
                <Modal
                    title={indicatorsModalTitle}
                    visible={indicatorsModalVisible}
                    onCancel={() => setIndicatorsModalVisible(false)}
                    footer={null}
                    width={'90%'}
                    bodyStyle={{ padding: 12 }}
                >
                    <Table
                        dataSource={indicatorsOfSource}
                        columns={indicatorColumns}
                        rowKey={(record) => record.ind_code}
                        pagination={{ pageSize: 10 }}
                        size="small"
                        scroll={{ x: 1400, y: 480 }}
                    />
                </Modal>
            </Row>,
        },
        /*
        {
            key: '2',
            label: 'WDG Source Table',
            children: <Table dataSource={wdgSources} columns={wdgColumns} rowKey="id" />,
        }
        */
    ];


    return (
        <Tabs defaultActiveKey="1" items={items} />
    );
};